import React from 'react'
import { ReactComponent as LogoEdumiam } from '../assets/edumiam.svg'

export type BrandConfig = {
  id: 'edumiam'
  hostname: string
  name: string
  LogoComponent: React.ComponentType<React.SVGProps<SVGSVGElement>>
  favicon: string
  pageTitle: string
  websiteUrl: string
  cssDataStyle: string
  footerTagline: string
  googleRating: number
  fonts: {
    body: string
    title: string
    titleFontWeight: string
    googleFontsUrl?: string
  }
}

export const BRAND_REGISTRY: BrandConfig[] = [
  {
    id: 'edumiam',
    hostname: 'inscription.edumiam.com',
    name: 'Edumiam',
    LogoComponent: LogoEdumiam,
    favicon: 'https://walter-resources.s3.eu-west-3.amazonaws.com/static/favicon/edumiam.png',
    pageTitle: "Edumiam - Le goût d'apprendre",
    websiteUrl: 'https://www.edumiam.com',
    cssDataStyle: 'edumiam',
    footerTagline: "Le goût d'apprendre",
    googleRating: 4.9,
    fonts: {
      body: 'Raleway',
      title: 'Raleway',
      titleFontWeight: '700',
      googleFontsUrl:
        'https://fonts.googleapis.com/css2?family=Raleway:wght@400;500;600;700;800;900&display=swap',
    },
  },
]

const DEFAULT_BRAND = BRAND_REGISTRY[0]

export function matchesBrandHostname(hostname: string, brandHostname: string): boolean {
  if (!hostname) return false
  if (hostname === brandHostname) return true
  const baseDomain = brandHostname.replace(/^[^.]+\./, '')
  return hostname === baseDomain || hostname.endsWith(`.${baseDomain}`)
}

export function getBrandConfig(hostnameOrId?: string | null): BrandConfig {
  if (!hostnameOrId) return DEFAULT_BRAND

  const byHostname = BRAND_REGISTRY.find((entry) => matchesBrandHostname(hostnameOrId, entry.hostname))
  if (byHostname) return byHostname

  const byId = BRAND_REGISTRY.find((entry) => entry.id === hostnameOrId)
  if (byId) return byId

  return DEFAULT_BRAND
}

export const BrandContext = React.createContext<BrandConfig>(DEFAULT_BRAND)

export function useBrand(): BrandConfig {
  return React.useContext(BrandContext)
}
